(function (Translator) {
    // en
    Translator.add("address", "Address:", "PayseraMapBundle", "en");
    Translator.add("friday", "Friday", "PayseraMapBundle", "en");
    Translator.add("monday", "Monday", "PayseraMapBundle", "en");
    Translator.add("no_results", "No results found", "PayseraMapBundle", "en");
    Translator.add("saturday", "Saturday", "PayseraMapBundle", "en");
    Translator.add("search_placeholder", "Enter a fragmet", "PayseraMapBundle", "en");
    Translator.add("service.cash_in", "Cash-in", "PayseraMapBundle", "en");
    Translator.add("service.cash_out", "Cash-out", "PayseraMapBundle", "en");
    Translator.add("service.identification", "Identification", "PayseraMapBundle", "en");
    Translator.add("service.pay", "Payments", "PayseraMapBundle", "en");
    Translator.add("services", "Services:", "PayseraMapBundle", "en");
    Translator.add("sunday", "Sunday", "PayseraMapBundle", "en");
    Translator.add("thursday", "Thursday", "PayseraMapBundle", "en");
    Translator.add("tuesday", "Tuesday", "PayseraMapBundle", "en");
    Translator.add("wednesday", "Wednesday", "PayseraMapBundle", "en");
    Translator.add("working_hours", "Working hours:", "PayseraMapBundle", "en");
})(Translator);
